import type { IconSvgObject } from './types';

const ArrangeByNumbersOneNineIcon: IconSvgObject = [
  ["path", { d: "M7 10.0001V2.99988L5.5 3.99988M7 10.0001L5.5 9.99988M7 10.0001L8.5 9.99988", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 17.4999V13.9999H5V17.4999H9ZM9 17.4999V20.9999H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.5 3.99988V19.1963M14 17.4999L16.5 19.9999L19 17.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrangeByNumbersOneNineIcon;
